export const DEFAULT = 'default';
export const ON_DARK = 'on-dark';